/* ------------------------------------------------------------------
   THE SANDLOT SPORTS — Shopify theme JS
   Rendering is server-side (Liquid). This is the interaction layer:
   AJAX cart + drawer, hero slider, collection filters, PDP gallery,
   reveals, rails, tile parallax, mobile menu.
------------------------------------------------------------------- */
(function () {
  "use strict";

  var fmt = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
  function money(cents) { return fmt.format((cents || 0) / 100); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }

  /* ---------- toast ---------- */
  var toastEl, toastT;
  function toast(html) {
    if (!toastEl) { toastEl = document.createElement("div"); toastEl.className = "toast"; toastEl.setAttribute("role", "status"); toastEl.setAttribute("aria-live", "polite"); document.body.appendChild(toastEl); }
    toastEl.innerHTML = html;
    requestAnimationFrame(function () { toastEl.classList.add("show"); });
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove("show"); }, 3400);
  }

  /* ---------- drawer ---------- */
  var drawer = document.querySelector("[data-drawer]");
  var scrim = document.querySelector("[data-scrim]");
  function drawerOpen() { if (drawer) { drawer.classList.add("open"); scrim.classList.add("show"); document.body.style.overflow = "hidden"; } }
  function drawerClose() { if (drawer) { drawer.classList.remove("open"); scrim.classList.remove("show"); document.body.style.overflow = ""; } }

  /* ---------- Shopify AJAX cart ---------- */
  function setCount(n) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = n;
      el.style.display = n ? "grid" : "none";
    });
  }

  function renderCart(cart) {
    setCount(cart.item_count);
    var body = document.querySelector("[data-cart-body]");
    var totalEl = document.querySelector("[data-cart-total]");
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-empty"><div class="display">Nothing in the box</div>' +
        '<p>Fresh wax is waiting.</p><a class="btn btn-bolt" href="/collections/all" style="margin-top:14px">Shop new releases</a></div>';
      if (totalEl) totalEl.textContent = money(0);
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]{3,4})(\?|$)/i, "_160x$1$2") : "";
      return '<div class="cart-line">' +
        '<a class="thumb" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="">' : "") + '</a>' +
        '<div><div class="t">' + esc(it.product_title) + '</div>' +
          '<div class="meta"><span class="qty">' +
            '<button data-qty="-1" data-key="' + esc(it.key) + '" data-cur="' + it.quantity + '" aria-label="Decrease quantity">−</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button data-qty="1" data-key="' + esc(it.key) + '" data-cur="' + it.quantity + '" aria-label="Increase quantity">+</button></span>' +
          '<button class="rm" data-rm-key="' + esc(it.key) + '">Remove</button></div></div>' +
        '<span class="p">' + money(it.final_line_price) + '</span>' +
      '</div>';
    }).join("");
    if (totalEl) totalEl.textContent = money(cart.total_price);
  }

  function refreshCart() {
    return fetch("/cart.js").then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  function cartAdd(variantId, qty) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    }).then(function (item) {
      toast('<span class="y">Added:</span> ' + esc(item.product_title || "item"));
      return refreshCart();
    }).then(drawerOpen).catch(function (e) {
      toast(esc((e && e.description) || "Couldn't add that — try again."));
    });
  }

  function cartChange(key, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  /* ---------- reveals ---------- */
  function reveals() {
    var els = document.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window)) { els.forEach(function (e) { e.classList.add("in"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: "0px 0px -6% 0px" });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- sport-tile parallax ---------- */
  function tileParallax() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (!window.matchMedia("(hover: hover)").matches) return;
    document.querySelectorAll(".tile").forEach(function (tile) {
      var im = tile.querySelector("img");
      if (!im) return;
      tile.addEventListener("pointermove", function (e) {
        var r = tile.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width - 0.5) * 2;
        var y = ((e.clientY - r.top) / r.height - 0.5) * 2;
        im.style.transform = "scale(1.1) translate(" + (x * 12).toFixed(1) + "px," + (y * 12).toFixed(1) + "px)";
      });
      tile.addEventListener("pointerleave", function () { im.style.transform = ""; });
    });
  }

  /* ---------- rails ---------- */
  function rails() {
    document.querySelectorAll("[data-rail]").forEach(function (rail) {
      var track = rail.querySelector(".rail-track");
      var wrap = rail.closest(".container") || rail.parentElement;
      wrap.querySelectorAll("[data-rail-btn]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var dir = btn.getAttribute("data-rail-btn") === "next" ? 1 : -1;
          track.scrollBy({ left: dir * (track.clientWidth * 0.8), behavior: "smooth" });
        });
      });
    });
  }

  /* ---------- hero slider (slides come from Liquid JSON) ---------- */
  function heroSlider() {
    var root = document.querySelector("[data-hero]");
    if (!root) return;
    var dataEl = root.querySelector("[data-slide-data]");
    var list = [];
    try { list = JSON.parse(dataEl.textContent); } catch (e) {}
    list = (list || []).filter(function (s) { return s && s.title; });
    if (!list.length) { root.querySelector(".hero-drop").style.display = "none"; return; }

    var bgWrap = root.querySelector("[data-slides]");
    var dots = root.querySelector("[data-dots]");
    var boxLink = root.querySelector("[data-drop-box]");
    var boxImg = boxLink.querySelector("img");
    var cap = root.querySelector("[data-drop-caption]");

    bgWrap.innerHTML = list.map(function (s) {
      return '<div class="hero-bg" style="background-image:url(' + s.bg + ')"></div>';
    }).join("");
    dots.innerHTML = list.map(function (s, i) {
      return '<button class="hero-dot" data-dot="' + i + '" role="tab" aria-label="' + esc(s.title) + '"></button>';
    }).join("");

    var bgs = [].slice.call(bgWrap.children);
    var dotEls = [].slice.call(dots.children);
    var idx = -1, timer = null;
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function show(n) {
      idx = (n + list.length) % list.length;
      var s = list[idx];
      bgs.forEach(function (el, i) { el.classList.toggle("active", i === idx); });
      dotEls.forEach(function (el, i) {
        el.classList.remove("active");
        if (i === idx) { void el.offsetWidth; el.classList.add("active"); }
        el.setAttribute("aria-selected", i === idx ? "true" : "false");
      });
      boxLink.href = s.url;
      boxImg.src = s.box;
      boxImg.alt = s.title;
      boxLink.style.animation = "none"; void boxLink.offsetWidth; boxLink.style.animation = "";
      cap.innerHTML =
        '<span class="eyebrow">' + esc(s.kicker || "Just landed") + '</span>' +
        '<a class="name" href="' + esc(s.url) + '">' + esc(s.title.replace(/ - /g, " — ")) + '</a>' +
        '<span class="row">' + esc(s.price) +
          (s.available ? '<span class="pill in">In stock</span>' : '<span class="pill out">Sold out</span>') +
        '</span>';
      restart();
    }
    function restart() {
      clearTimeout(timer);
      if (!reduce) timer = setTimeout(function () { show(idx + 1); }, 7000);
    }
    root.querySelector("[data-slide-next]").addEventListener("click", function () { show(idx + 1); });
    root.querySelector("[data-slide-prev]").addEventListener("click", function () { show(idx - 1); });
    dots.addEventListener("click", function (e) {
      var d = e.target.closest("[data-dot]"); if (d) show(+d.getAttribute("data-dot"));
    });
    root.addEventListener("pointerenter", function () {
      clearTimeout(timer);
      var a = dots.querySelector(".hero-dot.active"); if (a) a.classList.add("paused");
    });
    root.addEventListener("pointerleave", function () {
      var a = dots.querySelector(".hero-dot.active"); if (a) a.classList.remove("paused");
      restart();
    });
    show(0);
  }

  /* ---------- collection filtering (server-rendered cards) ---------- */
  function shopFilters() {
    var grid = document.querySelector("[data-shop-grid]");
    if (!grid) return;
    var cards = [].slice.call(grid.querySelectorAll("[data-pitem]"));
    if (!cards.length) return;
    cards.forEach(function (c, i) { c.dataset.idx = i; });

    var chipsWrap = document.querySelector("[data-chips]");
    var search = document.querySelector("[data-search]");
    var sort = document.querySelector("[data-sort]");
    var countEl = document.querySelector("[data-count]");
    var emptyEl = document.querySelector("[data-empty]");

    var state = { sport: null, q: "", sort: "featured", stock: false };
    var params = new URLSearchParams(location.search);
    if (params.get("sport")) state.sport = params.get("sport");

    // hide chips with no matches
    if (chipsWrap) {
      var present = {};
      cards.forEach(function (c) { present[c.dataset.sport] = true; });
      chipsWrap.querySelectorAll(".chip").forEach(function (ch) {
        var s = ch.getAttribute("data-sport");
        if (s && !present[s]) ch.remove();
        else ch.classList.toggle("active", s === (state.sport || ""));
      });
    }

    function apply() {
      var visible = [];
      cards.forEach(function (c) {
        var ok = true;
        if (state.sport && c.dataset.sport !== state.sport) ok = false;
        if (ok && state.q && (c.dataset.title + " " + c.dataset.sport).toLowerCase().indexOf(state.q.toLowerCase()) === -1) ok = false;
        if (ok && state.stock && c.dataset.available !== "1") ok = false;
        c.style.display = ok ? "" : "none";
        if (ok) visible.push(c);
      });

      var sorted = visible.slice();
      if (state.sort === "price-asc") sorted.sort(function (a, b) { return a.dataset.price - b.dataset.price; });
      else if (state.sort === "price-desc") sorted.sort(function (a, b) { return b.dataset.price - a.dataset.price; });
      else if (state.sort === "az") sorted.sort(function (a, b) { return a.dataset.title.localeCompare(b.dataset.title); });
      else sorted.sort(function (a, b) {
        return (b.dataset.new - a.dataset.new) || (b.dataset.available - a.dataset.available) || (a.dataset.idx - b.dataset.idx);
      });
      sorted.forEach(function (c) { grid.appendChild(c); });

      if (countEl) countEl.textContent = visible.length + " box" + (visible.length === 1 ? "" : "es") +
        (state.sport ? " · " + state.sport : "") + (state.q ? ' · "' + state.q + '"' : "");
      if (emptyEl) emptyEl.hidden = visible.length > 0;
    }

    if (chipsWrap) chipsWrap.addEventListener("click", function (e) {
      var b = e.target.closest(".chip"); if (!b || b.hasAttribute("data-stock")) return;
      state.sport = b.getAttribute("data-sport") || null;
      chipsWrap.querySelectorAll(".chip").forEach(function (c) { c.classList.toggle("active", c === b); });
      var url = new URL(location); if (state.sport) url.searchParams.set("sport", state.sport); else url.searchParams.delete("sport");
      history.replaceState(null, "", url);
      apply();
    });
    if (search) { var t; search.addEventListener("input", function () { clearTimeout(t); t = setTimeout(function () { state.q = search.value.trim(); apply(); }, 160); }); }
    if (sort) sort.addEventListener("change", function () { state.sort = sort.value; apply(); });
    var stockToggle = document.querySelector("[data-stock]");
    if (stockToggle) stockToggle.addEventListener("click", function () {
      state.stock = !state.stock; stockToggle.classList.toggle("active", state.stock); apply();
    });
    apply();
  }

  /* ---------- PDP gallery + buy bar ---------- */
  function pdp() {
    var root = document.querySelector("[data-pdp]");
    if (!root) return;
    var main = root.querySelector("[data-p-img]");
    var thumbs = root.querySelector("[data-p-thumbs]");
    if (thumbs && main) {
      thumbs.addEventListener("click", function (e) {
        var b = e.target.closest(".pdp-thumb"); if (!b) return;
        main.src = b.getAttribute("data-full");
        thumbs.querySelectorAll(".pdp-thumb").forEach(function (t) { t.classList.toggle("active", t === b); });
      });
    }
    var bar = document.querySelector("[data-buybar]");
    var buyBox = root.querySelector(".buy-box");
    if (bar && buyBox) {
      window.addEventListener("scroll", function () {
        var r = buyBox.getBoundingClientRect();
        bar.classList.toggle("show", r.bottom < 0);
      }, { passive: true });
    }
  }

  /* ---------- global events ---------- */
  document.addEventListener("click", function (e) {
    var add = e.target.closest("[data-add]");
    if (add) { e.preventDefault(); cartAdd(add.getAttribute("data-add"), 1); return; }
    var qty = e.target.closest("[data-qty]");
    if (qty) {
      var next = parseInt(qty.getAttribute("data-cur"), 10) + parseInt(qty.getAttribute("data-qty"), 10);
      cartChange(qty.getAttribute("data-key"), Math.max(0, next));
      return;
    }
    var rm = e.target.closest("[data-rm-key]");
    if (rm) { cartChange(rm.getAttribute("data-rm-key"), 0); return; }
    if (e.target.closest("[data-cart-open]")) { e.preventDefault(); drawerOpen(); refreshCart(); return; }
    if (e.target.closest("[data-cart-close]") || e.target.closest("[data-scrim]")) { drawerClose(); return; }
    if (e.target.closest("[data-menu-open]")) { document.querySelector(".mobile-menu").classList.add("open"); document.body.style.overflow = "hidden"; return; }
    if (e.target.closest("[data-menu-close]")) { document.querySelector(".mobile-menu").classList.remove("open"); document.body.style.overflow = ""; return; }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      drawerClose();
      var m = document.querySelector(".mobile-menu.open");
      if (m) { m.classList.remove("open"); document.body.style.overflow = ""; }
    }
  });

  // AJAX product form
  document.querySelectorAll("[data-product-form]").forEach(function (f) {
    f.addEventListener("submit", function (e) {
      e.preventDefault();
      var fd = new FormData(f);
      cartAdd(fd.get("id"), 1);
    });
  });

  // hours — highlight today
  (function () {
    var list = document.querySelector("[data-hours]");
    if (!list) return;
    var d = new Date().getDay();
    var el = list.querySelector('[data-day="' + d + '"]');
    if (el) el.classList.add("today");
  })();

  /* ---------- release calendar: "hold one for me" ---------- */
  function holdRequests() {
    var dialog = document.querySelector("[data-hold-dialog]");
    if (!dialog) return;
    var titleEl = dialog.querySelector("[data-hold-title]");
    var whenEl = dialog.querySelector("[data-hold-when]");
    var bodyEl = dialog.querySelector("[data-hold-body]");
    var subjEl = dialog.querySelector("[data-hold-subject]");

    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-hold]");
      if (!btn) return;
      var row = btn.closest(".relcal-row");
      if (!row) return;
      var release = row.getAttribute("data-release") || "a release";
      var when = row.getAttribute("data-when") || "";

      titleEl.textContent = release;
      whenEl.textContent = when ? "Streets " + when : "";
      if (subjEl) subjEl.value = "Hold request — " + release;
      if (bodyEl) {
        bodyEl.value =
          "Hold request from the release calendar.\n\nRelease: " + release +
          (when ? "\nStreet date: " + when : "") +
          "\n\nThis is a request to be contacted — not an order.";
      }
      if (typeof dialog.showModal === "function") dialog.showModal();
      else dialog.setAttribute("open", "");
      var first = dialog.querySelector('input[type="text"]');
      if (first) setTimeout(function () { first.focus(); }, 40);
    });

    // Backdrop click closes.
    dialog.addEventListener("click", function (e) {
      if (e.target === dialog) dialog.close();
    });

    // If Shopify bounced back with ?contact_posted=true, re-open on the success state.
    if (/[?&]contact_posted=true/.test(location.search) && dialog.querySelector(".relcal-ok")) {
      if (typeof dialog.showModal === "function") dialog.showModal();
    }
  }

  /* ---------- boot ---------- */
  setCount((window.SandlotCFG && window.SandlotCFG.cartCount) || 0);
  refreshCart();
  heroSlider();
  shopFilters();
  pdp();
  reveals();
  rails();
  tileParallax();
  holdRequests();
})();
